import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import "./SkillsTab.css";

const cloudDevopsSreSkills = [
  {
    skillName: "AWS",
    fontAwesomeClassname: "simple-icons:amazonaws",
    style: { color: "#FF9900" },
  },
  {
    skillName: "Azure",
    fontAwesomeClassname: "simple-icons:microsoftazure",
    style: { color: "#0089D6" },
  },
  {
    skillName: "Google Cloud",
    fontAwesomeClassname: "simple-icons:googlecloud",
    style: { color: "#4285F4" },
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "simple-icons:docker",
    style: { color: "#1488C6" },
  },
  {
    skillName: "Kubernetes",
    fontAwesomeClassname: "simple-icons:kubernetes",
    style: { color: "#326CE5" },
  },
  {
    skillName: "Terraform",
    fontAwesomeClassname: "simple-icons:terraform",
    style: { color: "#7B42BC" },
  },
  {
    skillName: "Ansible",
    fontAwesomeClassname: "simple-icons:ansible",
    style: { color: "#EE0000" },
  },
  {
    skillName: "Jenkins",
    fontAwesomeClassname: "simple-icons:jenkins",
    style: { color: "#D24939" },
  },
  {
    skillName: "GitHub Actions",
    fontAwesomeClassname: "simple-icons:githubactions",
    style: { color: "#2088FF" },
  },
  {
    skillName: "GitLab CI",
    fontAwesomeClassname: "simple-icons:gitlab",
    style: { color: "#FC6D26" },
  },
  {
    skillName: "Prometheus",
    fontAwesomeClassname: "simple-icons:prometheus",
    style: { color: "#E6522C" },
  },
  {
    skillName: "Grafana",
    fontAwesomeClassname: "simple-icons:grafana",
    style: { color: "#F46800" },
  },
  {
    skillName: "Elastic Stack (ELK)",
    fontAwesomeClassname: "simple-icons:elasticsearch",
    style: { color: "#005571" },
  },
  {
    skillName: "Linux",
    fontAwesomeClassname: "simple-icons:linux",
    style: { color: "#FCC624" },
  },
  {
    skillName: "Python",
    fontAwesomeClassname: "simple-icons:python",
    style: { color: "#3776AB" },
  },
  {
    skillName: "Java",
    fontAwesomeClassname: "simple-icons:java",
    style: { color: "#007396" },
  },
  {
    skillName: "Shell Scripting",
    fontAwesomeClassname: "simple-icons:shell",
    style: { color: "#4EAA25" },
  },
  {
    skillName: "Bash Scripting",
    fontAwesomeClassname: "simple-icons:gnubash",
    style: { color: "#4EAA25" },
  },
  {
    skillName: "Site Reliability Engineering",
    fontAwesomeClassname: "simple-icons:datadog",
    style: { color: "#4285F4" },
  },
  {
    skillName: "Helm",
    fontAwesomeClassname: "simple-icons:helm",
    style: { color: "#0F1689" },
  },
  {
    skillName: "Argo CD",
    fontAwesomeClassname: "simple-icons:argo",
    style: { color: "#EF7B4D" },
  },
  {
    skillName: "NGINX",
    fontAwesomeClassname: "simple-icons:nginx",
    style: { color: "#009639" },
  },
  {
    skillName: "Apache Kafka",
    fontAwesomeClassname: "simple-icons:apachekafka",
    style: { color: "#231F20" },
  },
  {
    skillName: "RabbitMQ",
    fontAwesomeClassname: "simple-icons:rabbitmq",
    style: { color: "#FF6600" },
  },
  {
    skillName: "Redis",
    fontAwesomeClassname: "simple-icons:redis",
    style: { color: "#DC382D" },
  },
  {
    skillName: "MySQL",
    fontAwesomeClassname: "simple-icons:mysql",
    style: { color: "#4479A1" },
  },
  {
    skillName: "PostgreSQL",
    fontAwesomeClassname: "simple-icons:postgresql",
    style: { color: "#336791" },
  },
  {
    skillName: "SonarQube",
    fontAwesomeClassname: "simple-icons:sonarqube",
    style: { color: "#4E9BCD" },
  },
  {
    skillName: "Sentry",
    fontAwesomeClassname: "simple-icons:sentry",
    style: { color: "#362D59" },
  },
  {
    skillName: "PagerDuty",
    fontAwesomeClassname: "simple-icons:pagerduty",
    style: { color: "#06AC38" },
  },
  {
    skillName: "Cloudflare",
    fontAwesomeClassname: "simple-icons:cloudflare",
    style: { color: "#F38020" },
  },
  {
    skillName: "Vault",
    fontAwesomeClassname: "simple-icons:vault",
    style: { color: "#000000" },
  },
  {
    skillName: "OpenTelemetry",
    fontAwesomeClassname: "simple-icons:opentelemetry",
    style: { color: "#000000" },
  },
  {
    skillName: "CI/CD Pipelines",
    fontAwesomeClassname: "simple-icons:git",
    style: { color: "#F05032" },
  },
  {
    skillName: "Jira",
    fontAwesomeClassname: "simple-icons:jira",
    style: { color: "#0052CC" },
  },
  {
    skillName: "Confluence",
    fontAwesomeClassname: "simple-icons:atlassian",
    style: { color: "#0052CC" },
  },
  {
    skillName: "Slack",
    fontAwesomeClassname: "simple-icons:slack",
    style: { color: "#000000" },
  },
  {
    skillName: "GitHub",
    fontAwesomeClassname: "simple-icons:github",
    style: { color: "#181717" },
  },
  {
    skillName: "Vercel",
    fontAwesomeClassname: "simple-icons:vercel",
    style: { color: "#000000" },
  },
  {
    skillName: "Domain & DNS Management",
    fontAwesomeClassname: "simple-icons:cloudflare",
    style: { color: "#F38020" },
  },
  {
    skillName: "Amazon Route 53",
    fontAwesomeClassname: "simple-icons:amazonroute53",
    style: { color: "#8C4FFF" },
  },
  {
    skillName: "Netlify",
    fontAwesomeClassname: "simple-icons:netlify",
    style: { color: "#00C7B7" },
  },
  {
    skillName: "NPM",
    fontAwesomeClassname: "simple-icons:npm",
    style: { color: "#CB3837" },
  },
  {
    skillName: "Yarn",
    fontAwesomeClassname: "simple-icons:yarn",
    style: { color: "#2C8EBB" },
  },
];

class SkillsTab extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div className="skills-tab-main">
        <Header theme={theme} />
        <div className="skills-tab-content main">
          <Fade bottom duration={1200} distance="30px">
            <h1 className="skills-tab-title" style={{ color: theme.text }}>
              Skills
            </h1>
            <p
              className="subTitle skills-tab-subtitle"
              style={{ color: theme.secondaryText }}
            >
              Cloud, DevOps and SRE tools & technologies
            </p>
          </Fade>

          <Fade bottom duration={1500} distance="30px">
            <div className="skills-grid">
              {cloudDevopsSreSkills.map((skill) => (
                <div
                  key={skill.skillName}
                  className="skill-grid-item"
                  style={{
                    border: `1px solid ${theme.secondaryText}`,
                    backgroundColor: theme.highlight,
                  }}
                >
                  <span
                    className="iconify skill-grid-icon"
                    data-icon={skill.fontAwesomeClassname}
                    style={skill.style}
                    data-inline="false"
                  ></span>
                  <span
                    className="skill-grid-name"
                    style={{ color: theme.text }}
                  >
                    {skill.skillName}
                  </span>
                </div>
              ))}
            </div>
          </Fade>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default SkillsTab;
